import { motion } from "framer-motion";

// Page entrance/exit transition wrapper
export default function PageShell({ children, className = "", testId }) {
  return (
    <motion.main
      data-testid={testId}
      className={className}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5, ease: "easeInOut" }}
    >
      {children}
    </motion.main>
  );
}
